import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function PhysicalExam({ index, item }) {
  return <QuestionHOC item={item} index={index}>
    <p className="mt-3" style={{ fontSize: 18, fontWeight: 'bold' }}>Physical Exam</p>
    <p>Patient complain of pain to the head, left shoulder, right hand, left knee and low back/tail bone.</p>
  </QuestionHOC>
}